import { Component } from 'vue';

import YarnPatternsList from '@/components/YarnPatterns/YarnPatternsList.vue';
import { createCoreVueApp } from '@/entrypoints/shared/core-vue-app';
import { mountProductTab } from '@/entrypoints/shared/tab-mounter';

const mountSelector = '#js-yarn-patterns';
const boundTabSelector = '#tab-yarn-patterns';

// No props needed - get data from store like pattern products
const mounter = async (component: Component, target: HTMLElement) => {
  const app = await createCoreVueApp(component, target);
  app.mount(target);
};

mountProductTab(YarnPatternsList, mountSelector, boundTabSelector, mounter);
